<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
             
                <div class="form-row">
                    <div class="col-md-11">
                            <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.platforms.list.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead class="thead-dark">
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.platforms.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.platforms.label.whitelabel')}}</th>
                                <th class="border-top-0">{{$t('string.msg.platforms.label.whitelabelapi')}}</th>
                                <th class="border-top-0">{{$t('string.msg.platforms.label.logo')}}</th>
                                <th class="border-top-0">{{$t('string.msg.platforms.table.label.status')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                            <tr v-if="item.status == 'ACTIVE'">
                                <td>
                                    <span v-if="item.name">
                                        {{camelize(item.name)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.whiteLabelSystem">
                                        {{camelize(item.whiteLabelSystem)}}
                                    </span>
                                </td>   
                                <td>
                                    <span v-if="item.whiteLabelSystem">
                                        {{item.whiteLabelApi}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.logoURL && item.logoURL != 'http://'">
                                         <img  v-bind:src="`${domain}${item.logoURL}`" alt="image" height="60" width="60">
                                    </span>
                                    <span v-else>
                                           <label >{{$t('str.no.images')}}</label><br/> 
                                    </span>
                                </td>
                                <td v-if="item.status" >
                                    {{$t(item.status)}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      <Spinner />
      <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListServices';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();

export default {
  name: 'ListServices',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        companyTypes: [],
        filters: {
            typeService: '',
            name: '',
            status:'ACTIVE',
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    var vm = this;
    this.$eventHub.$on('refreshList', function(){
        vm.filter();
    })
  },
  mounted(){
  }
}
</script>

<style>
</style>
